import React, {useEffect, useState, useMemo} from "react";
import LoadingPopUp from "../../../components/Pop_ups/LoadingPopUp";
import {Button, Grid, TextField} from '@mui/material'
import { DatePicker } from "@mui/lab";
import './Constraint.css'
import moment from "moment";
import ErrorPopUp from "../../../components/Pop_ups/ErrorPopUp";
import { ResourceDisplayTable } from "./ResourceDisplayTable";
import { ColumnNames } from "./ResourceColumnNames";
import GridBreak from "../../GridBreak";
import HoverButton from "../../HoverButton";
import TextPopUp from "../../../components/Pop_ups/TextPopUp";
import { isInt, toInt } from "validator";
import { getProfileFromEmail } from "../../../util/ProfileHelper";
import { editSingleConstraint, postSingleConstraint } from "../../../util/admin-api-requests/ProjectHelper";

export function ConstraintPage(props) {

    const columns = useMemo(() => ColumnNames, []);
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [refresh, setRefresh] = useState(false)
    const [modifyExisting, setModifyExisting] = useState(false)
    const [editValues, setEditValues] = useState({
      id: 0,
      constraint_startdate:"",
      constraint_enddate: "",
      po_number: "",
      hours_max: 0,
    });


    const [showConstraintCreate, setShowConstraintCreate] = useState(false)
    const [submission, setSubmission] = useState({constraint_enddate: props.resource_end, constraint_startdate: moment().format('YYYY-MM-DD'), 
                                                project_id: props.project_id, resource_id: props.resource_id})
    const [error, setError] = useState(null)
    const [success, setSuccess] = useState(false)

    const findIndexFromID = function (ID)
    {
      let i = 0
      while (i < data.length)
      {
        if (data[i].id == ID) 
          return i
        i++
      }
      return -1
    }

    //A global variable to avoid race conditions with re-rendering the submission data.
    let aboutToBeSubmitted = null

    //Update the data field when we are told to submit or refresh
    useEffect(() => {
        //We are editing an already existant page
        if (modifyExisting)
        {
          const dataID = findIndexFromID(editValues.id)
          if (dataID < 0)
          {
            setLoading(false)
            setError("Can't find the entry to edit. Please try again.")
            setRefresh(false)
            return
          }

          if (data.find((dataVal, i) =>
          {
            if (dataVal.id === editValues.id)
              return false

            //Check if the end date is inside of the interval
            return ((moment(editValues.constraint_enddate).isBefore(dataVal.constraint_enddate) && 
            moment(editValues.constraint_enddate).isAfter(dataVal.constraint_startdate)) ||

            //Check if the start date is inside of the interval
            (moment(editValues.constraint_startdate).isBefore(dataVal.constraint_enddate) &&
            moment(editValues.constraint_startdate).isAfter(dataVal.constraint_startdate)) ||

            //Check if the start date is before the interval and the end date is after the start
            (moment(editValues.constraint_startdate).isBefore(dataVal.constraint_startdate) &&
            moment(editValues.constraint_enddate).isAfter(dataVal.constraint_startdate)) ||

            //Check if the end date is after the end of the interval and the start date is before
            //the same end of this interval
            (moment(editValues.constraint_startdate).isBefore(dataVal.constraint_enddate) &&
            moment(editValues.constraint_enddate).isAfter(dataVal.constraint_enddate)))
          }))
          {
            setError("This constraint will overlap with an existing constraint. Make sure there is no overlap between constraints.")
            setLoading(false)
            setRefresh(false)
            return
          }
          
          const newData = data
          newData[dataID].constraint_startdate = editValues.constraint_startdate
          newData[dataID].constraint_enddate = editValues.constraint_enddate
          newData[dataID].po_number = editValues.po_number
          newData[dataID].hours_max = editValues.hours_max
          getProfileFromEmail((email) =>
          {
            newData[dataID].modified_by = email.id
            newData[dataID].modified_time = moment().format('YYYY-MM-DD HH:mm:ss')
          })
          editSingleConstraint(newData[dataID], (resp) => {
            if (!resp)
              setError("Something went wrong editting this constraint. Please try again.")
            console.log(resp)
            newData[dataID].hours_worked = resp.constraint_changed.hours_worked
            setData(newData)
            setRefresh(false)

          }, new AbortController())
          
          
        }
        else
        {
          if (Boolean(submission.hours_max) && Boolean(submission.hours_max))
          {
            setLoading(true)
            if (data.find((dataVal) =>
            {
              if (dataVal.id === submission.id)
              return false

              //Check if the end date is inside of the interval
              return ((moment(submission.constraint_enddate).isBefore(dataVal.constraint_enddate) && 
              moment(submission.constraint_enddate).isAfter(dataVal.constraint_startdate)) ||

              //Check if the start date is inside of the interval
              (moment(submission.constraint_startdate).isBefore(dataVal.constraint_enddate) &&
              moment(submission.constraint_startdate).isAfter(dataVal.constraint_startdate)) ||

              //Check if the start date is before the interval and the end date is after the start
              (moment(submission.constraint_startdate).isBefore(dataVal.constraint_startdate) &&
              moment(submission.constraint_enddate).isAfter(dataVal.constraint_startdate)) ||

              //Check if the end date is after the end of the interval and the start date is before
              //the same end of this interval
              (moment(submission.constraint_startdate).isBefore(dataVal.constraint_enddate) &&
              moment(submission.constraint_enddate).isAfter(dataVal.constraint_enddate)))
            }))
            {
              setError("This constraint will overlap with an existing constraint. Make sure there is no overlap between constraints.")
              setLoading(false)
              setRefresh(false)
              return
            }
          //First re-render, so set data appropriately.
            else if (refresh)
            //Sets the submission information on front and backend.
            {
              aboutToBeSubmitted = submission
              getProfileFromEmail(setCreationMetadataAndSend)
              setSubmission({constraint_enddate: props.resource_end, constraint_startdate: moment().format('YYYY-MM-DD'), 
                                                      project_id: props.project_id, resource_id: props.resource_id})
            }
          }
        }
        
      }, [refresh, modifyExisting]);

      useEffect(() =>
      {
        if (!data[0])
          setData(props.constraints)
      }, [])

    const editSubmission = function (key, value)
    {
      const newSub = {...submission}
      if (key === 'constraint_enddate' || key === 'constraint_startdate')
        newSub[key] = moment.utc(value).format('YYYY-MM-DD')
      else
        newSub[key] = value
      setSubmission(newSub)
    }

    // Seperate ID creation to avoid race conditions for the ID.
    const setCreationMetadataAndSend = function (email)
    {
      const newSub = {...aboutToBeSubmitted}
      newSub['created_by'] = email.id
      newSub['created_time'] = moment().format('YYYY-MM-DD HH:mm:ss')
      newSub['modified_time'] = moment().format('YYYY-MM-DD HH:mm:ss')
      newSub['modified_by'] = email.id
      postSingleConstraint(newSub, (resp) => 
        {
          setLoading(false)
          if (!resp)
          {
            setError("Something has gone wrong on our end. Please try again.")
            return
          }
          newSub['hours_worked'] = resp.constraint_inserted.hours_worked          
          const newConstraints = data[0] ? data : props.constraints
          newConstraints.push(newSub)
          setData(newConstraints)
          setRefresh(false)
          

        }, new AbortController)
    }

    const submit = function ()
    {
      setLoading(true)
      let errorFields = []
      let date_conflicts = false

      try
      {
        if (!submission.hours_max)
          errorFields.push("Max Hours")
        else
        {
          if (isInt(submission.hours_max))
          {
            submission.hours_max = toInt(submission.hours_max)
          }
          else
          {
            let err = new Error("hours_numerical")
            err.name = "DateConflict"
            throw err
          }
        }

        if (!submission.constraint_startdate)
          errorFields.push("Start Date")

        if (!submission.constraint_enddate)
          errorFields.push("End Date")
        
        if(errorFields.length > 0){
              let err = new Error("missing fields")
              err.name = "FieldError"
              throw err
          }

        if (!props.resource_start || !props.resource_end)
          date_conflicts = 'ResourceFieldsEmpty'

        if (moment.utc(props.resource_start).endOf('day').isAfter(moment.utc(props.resource_end)))
          date_conflicts = "beginIsAfterEnd"

        if (moment.utc(props.resource_start).endOf('day').isAfter(moment.utc(submission.constraint_startdate)))
          date_conflicts = 'StartMisaligned'
       
        if (moment.utc(submission.constraint_enddate).endOf('day').isAfter(props.resource_end))
          date_conflicts = 'EndMisaligned'
        if (moment.utc(submission.constraint_startdate).endOf('day').isAfter(submission.constraint_enddate))
          date_conflicts = 'SubmissionStartAfterEnd'
        
        if (date_conflicts)
        {
          let err = new Error("Invalid Date Input")
          err.name = "DateConflict"
          throw err
        }
        setRefresh(true)
        setShowConstraintCreate(false)
      }
      catch(e)
      {
          setShowConstraintCreate(false)
          if(e.name === "FieldError")
          {
              console.error(e)
              setError(`Please make sure to fill out the following fields, ${errorFields}`)
              setLoading(false)
          }
          else if(e.name === "DateConflict")
          {
              console.error(e)
              if (date_conflicts === 'ResourceFieldsEmpty')
                setError("Make sure to initialize resource start and end dates.")
              else if (date_conflicts === "beginIsAfterEnd")
                setError("Make sure the constraint beginning date is before the end date.")
              else if (date_conflicts === 'StartMisaligned')
                setError("Make sure the constraint start date is after the resource's starting date.")
              else if (date_conflicts === 'EndMisaligned')
                setError("Make sure the constraint end date is before the resource's ending date.")
              else if (date_conflicts === 'SubmissionStartAfterEnd')
                setError("Make sure the submitted constraint start date is before the contraint's end date.")
              setLoading(false)
          }
          else if (e.name === 'hours_numerical')
          {
            console.error(e)
            setError("Make sure the maximum hours field is strictly numerical.")
            setLoading(false)
          }
          else
          {
              console.error(e)
              setError("Please Make Sure to Fill out all required Form Fields")
              setLoading(false)
          }
          setSubmission({constraint_enddate: props.resource_end, constraint_startdate: moment().format('YYYY-MM-DD'), 
                                                project_id: props.project_id, resource_id: props.resource_id})
      }
    }

    
  return (
  <div>
      <LoadingPopUp open={loading}/>
      <Grid
              container
              sx={{ width: '100%', justifyContent: "flex-end", alignItems: "flex-end" }}
            >
            <ErrorPopUp open={Boolean(error)} onClose={(event)=>{event.preventDefault(); setError("")}} errorContent={error}/>
            <TextPopUp title="Success!" content={success} 
                        onClose={(event)=> {event.preventDefault(); setSuccess("")}} open={Boolean(success)}/>
            {showConstraintCreate ? 
            <Grid container item xs={12} sx={{ width: '100%', justifyContent: "flex-end", alignItems: "flex-end" }}>
              <Button
                item
                variant="outlined"
                onClick={(event) => {
                  event.preventDefault();
                  setShowConstraintCreate(false)

                }}
                sx ={{marginBottom: "1%"}}
              >
                Hide Creation
            </Button> 
              <Grid container rowSpacing={2} sx={{marginTop: "1%", width:"100%", justifyContent:'center', alignItems:'center'}}>
                  <Grid item xs={11/4} container sx={{ml:'0.1%', mr:'0.1%'}}>
                      <TextField
                      label = "Maximum Hours"
                      fullWidth
                      required
                      value={submission.hours_max ? submission.hours_max : ""}
                      onChange={(e) => editSubmission("hours_max",  e.target.value)}
                      />
                  </Grid>
                  <Grid item xs={11/4} container sx={{ml:'0.1%', mr:'0.1%'}}>
                      <TextField label="PO Number"
                      fullWidth 
                      required
                      value={submission.po_number ? submission.po_number : ""}
                      onChange={(e) => editSubmission("po_number",e.target.value)}
                      />
                  </Grid>
                  <Grid item xs={11/4} container sx={{ml:'0.1%', mr:'0.1%'}} >
                      <DatePicker 
                      label="Start Date"
                      fullWidth
                      required
                      value={submission.constraint_startdate ? moment.utc(submission.constraint_startdate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')}
                      maxDate={submission.constraint_enddate ? moment.utc(submission.constraint_enddate) : undefined}
                      onChange={(value)=>editSubmission('constraint_startdate',value)}
                      renderInput={(params)=><TextField fullWidth required {...params}/>}/>
                  </Grid>
                  <Grid item xs={11/4} container sx={{ml:'0.1%', mr:'0.1%'}}>
                  <DatePicker 
                      fullWidth
                      label="End Date"
                      required
                      value={submission.constraint_enddate ? moment.utc(submission.constraint_enddate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')}
                      onChange={(value)=>editSubmission('constraint_enddate',value)}
                      minDate={submission.start_date ? moment.utc(submission.start_date) : undefined}
                      renderInput={(params)=><TextField fullWidth {...params}/>}/>
                  </Grid>
                  <GridBreak/>
                  <Grid container flexDirection = "column" rowSpacing={2} sx={{marginTop: "2%", width:"100%", justifyContent:'center', alignItems:'center'}}>
                    <HoverButton margin = "auto" variant="outlined" onClick={(event)=> {event.preventDefault(); submit()}} color="black">Submit Constraint</HoverButton>
                  </Grid>
              </Grid>
          </Grid>
            
            : 
            
            <Button
                item
                variant="outlined"
                onClick={(event) => {
                  event.preventDefault();
                  setShowConstraintCreate(true)

                }}
              >
                Create Constraint
            </Button> 
            }
              
            </Grid>
      {refresh ? 
      <></>
      :
      <ResourceDisplayTable
      setModifyExisting = {setModifyExisting}
      editValues={editValues}
      setEditValues={setEditValues}
      data={data}
      columns={columns}
      refresh={refresh}
      setRefresh={setRefresh}
      />  }
  </div>
  )

}